// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import logo from "../assets/Logo.webp"

// export default function Navbar() {
//   const [scrolled, setScrolled] = useState(false);
//   const [open, setOpen] = useState(false);

//   useEffect(() => {
//     const onScroll = () => setScrolled(window.scrollY > 10);
//     window.addEventListener("scroll", onScroll);
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   return (
//     <header
//       className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
//         scrolled ? "backdrop-blur-lg bg-white/20 shadow-lg" : "bg-transparent"
//       }`}
//     >
//       <div className="max-w-7xl mx-auto flex items-center justify-between py-3 px-4 md:px-8">
//         {/* Logo */}
//         <Link to="/" className="flex items-center gap-2">
//           <img
//             src={logo}
//             alt="PixlyBooth"
//             className="h-16 w-auto drop-shadow-lg"
//           />
//         </Link>

//         {/* Desktop nav */}
//         <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-100">
//           <a href="/" className="hover:text-[#E34364] transition">
//             Home
//           </a>
//           <a href="/" className="hover:text-[#E34364] transition">
//             About Us
//           </a>
//           <a href="/" className="hover:text-[#E34364] transition">
//             Our Services
//           </a>
//           <a href="/" className="hover:text-[#E34364] transition">
//             Backdrops
//           </a>
//           <a href="/" className="hover:text-[#E34364] transition">
//             Gallery
//           </a>
//           <a href="/" className="hover:text-[#E34364] transition">
//             Reviews
//           </a>
//         </nav>

//         {/* CTA */}
//         <a
//           href="#contact"
//           className="hidden md:inline-flex items-center gap-2 bg-[#E34364] text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg shadow-[#E34364]/40 hover:shadow-[#E34364]/60 hover:-translate-y-[1px] transition"
//         >
//           Book Now
//         </a>

//         {/* Mobile hamburger */}
//         <button
//           className="md:hidden text-white"
//           onClick={() => setOpen((o) => !o)}
//         >
//           <span className="sr-only">Toggle menu</span>
//           <div className="space-y-1">
//             <span
//               className={`block h-[2px] w-5 bg-white transition ${
//                 open ? "translate-y-[5px] rotate-45" : ""
//               }`}
//             />
//             <span
//               className={`block h-[2px] w-4 bg-white transition ${
//                 open ? "opacity-0" : ""
//               }`}
//             />
//             <span
//               className={`block h-[2px] w-5 bg-white transition ${
//                 open ? "-translate-y-[5px] -rotate-45" : ""
//               }`}
//             />
//           </div>
//         </button>
//       </div>

//       {/* Mobile dropdown */}
//       {open && (
//         <div className="md:hidden bg-black/90 backdrop-blur-lg border-t border-white/10">
//           <nav className="px-4 py-3 flex flex-col gap-3 text-sm text-white">
//             <a href="#about" onClick={() => setOpen(false)}>
//               About
//             </a>
//             <a href="#services" onClick={() => setOpen(false)}>
//               Services
//             </a>
//             <a href="#backdrops" onClick={() => setOpen(false)}>
//               Backdrops
//             </a>
//             <a href="#gallery" onClick={() => setOpen(false)}>
//               Gallery
//             </a>
//             <a href="#testimonials" onClick={() => setOpen(false)}>
//               Reviews
//             </a>
//             <a
//               href="#contact"
//               onClick={() => setOpen(false)}
//               className="mt-2 inline-flex justify-center bg-[#E34364] text-white px-4 py-2 rounded-full"
//             >
//               Book Now
//             </a>
//           </nav>
//         </div>
//       )}
//     </header>
//   );
// }

import React, { useEffect, useState, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/Logo.webp";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Smooth scroll to section (works even if you're on another route)
  const goToSection = useCallback(
    (id) => (e) => {
      e.preventDefault();
      setOpen(false);

      const scrollNow = () => {
        // wait a tick for DOM render
        requestAnimationFrame(() => {
          const el = document.getElementById(id);
          if (!el) return;

          // adjust for fixed navbar height
          const y = el.getBoundingClientRect().top + window.scrollY - 90;
          window.scrollTo({ top: y, behavior: "smooth" });
        });
      };

      if (location.pathname !== "/") {
        navigate("/", { replace: false });
        // small delay so Home mounts then scroll
        setTimeout(scrollNow, 50);
      } else {
        scrollNow();
      }
    },
    [location.pathname, navigate]
  );

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-lg bg-white/20 shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between py-3 px-4 md:px-8">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2" onClick={() => setOpen(false)}>
          <img src={logo} alt="PixlyBooth" className="h-16 w-auto drop-shadow-lg" />
        </Link>

        {/* Desktop nav (sections) */}
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-100">
          <a href="#home" onClick={goToSection("home")} className="hover:text-[#E34364] transition">
            Home
          </a>

          <a href="#about" onClick={goToSection("about")} className="hover:text-[#E34364] transition">
            About Us
          </a>

          <a
            href="#services"
            onClick={goToSection("services")}
            className="hover:text-[#E34364] transition"
          >
            Our Services
          </a>

          {/* Backdrops = different page */}
          <Link to="/backdrops" className="hover:text-[#E34364] transition">
            Backdrops
          </Link>

          <a
            href="#gallery"
            onClick={goToSection("gallery")}
            className="hover:text-[#E34364] transition"
          >
            Gallery
          </a>

          <a
            href="#reviews"
            onClick={goToSection("testimonials")}
            className="hover:text-[#E34364] transition"
          >
            Reviews
          </a>
        </nav>

        {/* CTA -> contact section */}
        <button
          onClick={goToSection("contact")}
          className="hidden md:inline-flex items-center gap-2 bg-[#E34364] text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg shadow-[#E34364]/40 hover:shadow-[#E34364]/60 hover:-translate-y-[1px] transition"
        >
          Book Now
        </button>

        {/* Mobile hamburger */}
        <button className="md:hidden text-white" onClick={() => setOpen((o) => !o)}>
          <span className="sr-only">Toggle menu</span>
          <div className="space-y-1">
            <span
              className={`block h-[2px] w-5 bg-white transition ${
                open ? "translate-y-[5px] rotate-45" : ""
              }`}
            />
            <span className={`block h-[2px] w-4 bg-white transition ${open ? "opacity-0" : ""}`} />
            <span
              className={`block h-[2px] w-5 bg-white transition ${
                open ? "-translate-y-[5px] -rotate-45" : ""
              }`}
            />
          </div>
        </button>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div className="md:hidden bg-black/90 backdrop-blur-lg border-t border-white/10">
          <nav className="px-4 py-3 flex flex-col gap-3 text-sm text-white">
            <a href="#home" onClick={goToSection("home")}>Home</a>
            <a href="#about" onClick={goToSection("about")}>About Us</a>
            <a href="#services" onClick={goToSection("services")}>Our Services</a>

            {/* Backdrops = page */}
            <Link to="/backdrops" onClick={() => setOpen(false)}>Backdrops</Link>

            <a href="#gallery" onClick={goToSection("gallery")}>Gallery</a>
            <a href="#reviews" onClick={goToSection("testimonials")}>Reviews</a>

            <button
              onClick={goToSection("contact")}
              className="mt-2 inline-flex justify-center bg-[#E34364] text-white px-4 py-2 rounded-full"
            >
              Book Now
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}
